module.exports = __webpack_public_path__ + "img/Bungalow.adabfce7.svg";